import React, { useState, useEffect } from "react";
import "./LandscapeWarning.css";

const LandscapeWarning = () => {
  const [isLandscape, setIsLandscape] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check if device is mobile (not tablet)
    const checkIfMobile = () => {
      // Most tablets have a width greater than 768px
      const isTablet = window.innerWidth >= 768 && window.innerHeight >= 768;
      // Check if it's a mobile device and not a tablet
      setIsMobile(
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) && !isTablet
      );
    };

    // Function to check orientation
    const checkOrientation = () => {
      if (window.matchMedia("(orientation: landscape)").matches) {
        setIsLandscape(true);
      } else {
        setIsLandscape(false);
      }
    };

    // Initial checks
    checkIfMobile();
    checkOrientation();

    // Add event listeners for orientation change and resize
    window.addEventListener("orientationchange", checkOrientation);
    window.addEventListener("resize", () => {
      checkOrientation();
      checkIfMobile();
    });

    // Clean up event listeners
    return () => {
      window.removeEventListener("orientationchange", checkOrientation);
      window.removeEventListener("resize", () => {
        checkOrientation();
        checkIfMobile();
      });
    };
  }, []);

  // Only show the warning if it's a mobile device in landscape mode
  if (!isMobile || !isLandscape) {
    return null;
  }

  return (
    <div className="landscape-warning">
      <div className="landscape-warning__container">
        <div className="landscape-warning__icon">
          <svg viewBox="0 0 24 24" width="48" height="48">
            <path
              fill="currentColor"
              d="M7.5,21.5C4.25,21.5 1.5,18.75 1.5,15.5V8.5C1.5,5.5 4,3 7,3H17C20,3 22.5,5.5 22.5,8.5V15.5C22.5,18.75 19.75,21.5 16.5,21.5H7.5M7,4.5C4.75,4.5 3,6.25 3,8.5V15.5C3,17.75 5,19.5 7.5,19.5H16.5C19,19.5 21,17.75 21,15.5V8.5C21,6.25 19.25,4.5 17,4.5H7M7,6.5H17C18.1,6.5 19,7.4 19,8.5V15.5C19,16.6 18.1,17.5 17,17.5H7C5.9,17.5 5,16.6 5,15.5V8.5C5,7.4 5.9,6.5 7,6.5M16,14.25L14.25,16L12,13.75L9.75,16L8,14.25L10.25,12L8,9.75L9.75,8L12,10.25L14.25,8L16,9.75L13.75,12L16,14.25Z"
            />
          </svg>
        </div>
        <div className="landscape-warning__text">
          <h1>Please rotate your device</h1>
          <p>
            For the best experience, please use your device in portrait mode.
          </p>
        </div>
        <div className="landscape-warning__rotate-icon">
          <svg viewBox="0 0 24 24" width="64" height="64">
            <path
              fill="currentColor"
              d="M7.34,6.41L0.86,12.9L7.35,19.38L13.84,12.9L7.34,6.41M3.69,12.9L7.35,9.24L11,12.9L7.34,16.56L3.69,12.9M19.36,6.64C17.61,4.88 15.3,4 13,4V0.76L8.76,5L13,9.24V6C14.79,6 16.58,6.68 17.95,8.05C20.68,10.78 20.68,15.22 17.95,17.95C16.58,19.32 14.79,20 13,20C12.45,20 11.95,19.94 11.42,19.83C10.86,19.71 10.3,20.06 10.17,20.63C10.08,21.19 10.39,21.75 10.96,21.87C11.62,22.05 12.3,22.13 13,22.13C15.3,22.13 17.61,21.25 19.36,19.5C22.88,15.97 22.88,10.03 19.36,6.5V6.64Z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default LandscapeWarning;
